module.exports = "https://cdn2-fs.clearscore.com/flux/images/e36f588f698f291231ad38fe4b999c14.jpg";